import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Popup as RuiPopup} from 'rambler-ui'
import styles from './styles.css'
import stylesButtons from 'components/PopupButtons/styles.css'

export default class Popup extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    promo: PropTypes.bool,
    children: PropTypes.node
  }

  componentDidMount() {
    document.body.classList.add(styles.locked)
  }

  componentWillUnmount() {
    document.body.classList.remove(styles.locked)
  }

  render() {
    const {
      className = '',
      titleClassName = '',
      promo,
      title,
      children,
      ...props
    } = this.props

    return (
      <RuiPopup
        {...props}
        title={title}
        className={`${styles.root} ${promo ? styles.promo : ''} ${className}`}
        titleClassName={`${styles.title} ${titleClassName}`}
        buttonsContainerClassName={stylesButtons.root}
      >
        <div className={styles.content}>{children}</div>
      </RuiPopup>
    )
  }
}
